import * as React from 'react'
import Box from '@mui/material/Box'
import { FormControl, TextField, Button, Alert } from '@mui/material'
import ReCAPTCHA from 'react-google-recaptcha'
import axios from 'axios'

function AppRequestForm() { 

    const [name,setName] = React.useState("")
    const [email,setEmail] = React.useState("");
    const [confirmEmail, setConfirmEmail] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [error, setError] = React.useState(false)
    const [success, setSuccess] = React.useState(false)

    const captchaRef = React.useRef(null)
    
    const handleFormSubmit = async e => { 
        e.preventDefault()
        setError(false)
        setSuccess(false)
        if (name === "") {
            setError(true)
            setMessage("Please enter your name.")
        } else if (email === "") {
            setError(true)
            setMessage("Please enter your email address.")
        } else if (confirmEmail === "") {
            setError(true)
            setMessage("Please confirm your email address.")
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)||
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(confirmEmail)) {
            setError(true)
            setMessage("Invalid email address, please try again.")
        } else if (email.trim() !== confirmEmail.trim()) {
            setError(true)
            setMessage("Email addresses do not match.")
        } else { 
            let token = captchaRef.current.getValue()
            captchaRef.current.reset()
            if (!token) {
                setError(true)
                setMessage("Please use reCAPTCHA to prove that you are not a Robot.")
            } else { 
                //console.log(token)
                let valid_token = verifyToken(token)
            }
        }
    }

    const verifyToken = async (token) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_SERVICE_URL +
                '/RequestAppRedemption?token=' +
                token.trim() +
                '&name=' + name.trim() + 
                '&email=' + email.trim() +
                '&mobileOS=IOS&appType=OE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
            redirect: 'follow'
        }
        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data))
                if (response.data.success) { 
                    allGood()
                } else {
                    setError(true)
                    setMessage("ReCAPTCHA validation failed. Please retry to prove that you are a not a Robot.")
                }
            })
            .catch((error) => {
                console.log(error)
            })
        
    }    

    const allGood = () => { 
        setError(false)
        setMessage("Your request has been submitted. Please check your email for details.")
        setSuccess(true)
        setName("")
        setEmail("")
        setConfirmEmail("")
    }

    return (

        <>

            <Box
                sx={{
                    width: '100%',
                    height: '80vh',
                    textAlign: 'center',
                    backgroundColor: 'white',
                    border: '1px solid lightGray',
                    borderRadius: '5px'
                }}
            >
                
                <div>
                    <Box
                        component='img'
                        sx={{
                            height: '30%',
                            width: '30%',
                            maxHeight: { xs: '30', md: '30' },
                            maxWidth: { xs: '30', md: '30' },
                            minHeight: { xs: '30', md: '30' },
                            minWidth: { xs: '30', md: '30' },
                            textAlign: 'center',
                        }}
                        src={process.env.PUBLIC_URL + "/company_logo_banner.png"}
                    >
                    </Box>
                </div>
                
                <div>
                    <FormControl
                        id="myAppRequestForm"
                        className="formContainer"
                        onSubmit={handleFormSubmit}
                        sx={{ minWidth: '75%' }}>
                        
                        <TextField
                            sx={{
                                textAlign: 'center',
                                marginTop: '2px',
                                width: '100%'
                            }}
                            id="name"
                            label="Name"
                            onChange={e => setName(e.target.value)}
                            variant="outlined"
                            className='formGroup'
                            value={name}
                            required />
                        <TextField
                            sx={{
                                textAlign: 'center',
                                marginTop: '10px',
                                width: '100%'
                            }}
                            id="email"
                            label="Email"
                            onChange={e => setEmail(e.target.value)}
                            variant="outlined"
                            className='formGroup'
                            value={email}
                            required />
                        <TextField
                            sx={{
                                textAlign: 'center',
                                marginTop: '10px',
                                width: '100%'
                            }}
                            id="email"
                            label="Confirm Email"
                            onChange={e => setConfirmEmail(e.target.value)}
                            variant="outlined"
                            className='formGroup'
                            value={confirmEmail}
                            required />
                        
                        &nbsp;

                        <Box
                            sx={{
                                textAlign: 'center',
                                display: 'inline-block',
                                width: '304px',
                                margin: '0 auto'
                            }}>
                            <ReCAPTCHA
                                sx={{display: 'inline-block', textAlign: 'center'}}
                                sitekey={process.env.REACT_APP_SITE_KEY}
                                ref={captchaRef} 
                            />
                        </Box>
                        
                        <Button
                            sx={{
                                textAlign: 'center',
                                marginTop: '20px',
                                width: '100%'
                            }}
                            type="submit"
                            variant="contained"
                            onClick={handleFormSubmit}>
                            SUBMIT
                        </Button>

                        {
                            error && <Alert sx={{ textAlign: 'center', marginTop: '10px' }} severity="error">{message}</Alert> 
                        }

                        {
                            !error && success && <Alert sx={{ textAlign: 'center', marginTop: '10px' }} severity="success">{message}</Alert> 
                        }

                    </FormControl>
                </div>

            </Box>

        </>

    )

}

export default AppRequestForm